import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { capitalize } from "src/shared/helpers/capitalize"
import { ProductividadCamaristasDetailProps } from "./ProductividadCamaristasDetail.type"
import "./ProductividadCamaristasDetail.css"

const emptyValue = "-"

const ProductividadCamaristasDetail = ({ isOpen, onClose, data }: ProductividadCamaristasDetailProps): JSX.Element => {
    // las fechas del reporte ya llegan formateadas desde el endpoint, se muestran igual que en la tabla
    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="limpieza-supervision-detail">
            <div className="limp-detail__head">
                <p className="limp-detail__title">Limpieza y supervisión</p>
            </div>
            <div className="limp-detail__body">
                <div className="limp-detail__description">
                    <DescriptionDetail
                        icon={"buildingFill"}
                        label={"Tipo de habitación"}
                        value={data?.tipo_habitacion || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"building4Fill"}
                        label={"Habitación"}
                        value={data?.habitacion || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"businessStar"}
                        label={"Tipo de limpieza"}
                        value={data?.tipo_limpieza ? capitalize(data.tipo_limpieza) : emptyValue}
                    />
                    <DescriptionDetail
                        className={"limp-detail__value--full"}
                        icon={"userFilled"}
                        label={"Camarista"}
                        value={data?.camarista || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"Clock"}
                        label={"Inicio de limpieza"}
                        value={data?.inicio_limpieza || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"AlarmFill"}
                        label={"Fin de limpieza"}
                        value={data?.fin_limpieza || emptyValue}
                    />
                    <DescriptionDetail
                        className={"limp-detail__value--full"}
                        icon={"UserSearchFill"}
                        label={"Supervisor"}
                        value={data?.supervisor || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"Clock"}
                        label={"Inicio de supervisión"}
                        value={data?.["Inicio supervision"] || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"AlarmFill"}
                        label={"Fin de supervisión"}
                        value={data?.fin_supervision || emptyValue}
                    />
                    <DescriptionDetail
                        className={"limp-detail__value--multiline"}
                        icon={"chat"}
                        label={"Comentarios"}
                        value={data?.observaciones || emptyValue}
                    />
                </div>
            </div>
        </Drawer>
    )
}

export default ProductividadCamaristasDetail
